import React, {useState} from "react";
import {addNewSkillType} from "../../../../service/adminService";
import {Button, ButtonToolbar, Form, Modal} from "rsuite";
import {adminSkillTypeModel} from "../../../form/models";

const AddSkillTypeModal = (props) => {
    const { open, handleClose } = props

    const [localState, setLocalState] = useState();

    const submitSkillTypeAdd = (isFormValid) => {
        if(!isFormValid) return;
        addNewSkillType(localState).then((response) => {
            handleClose(response);
        });
    };

    // rsuite does not have an onSubmit, we must handle state changes per controlled field
    const handleFormChange = (event) => {
        setLocalState({...localState, ...event});
    }

    return (
        <Modal
            open={open}
            onClose={handleClose}
            backdrop="static"
        >
            <Modal.Header>
                <Modal.Title>Add Skill Type</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            </Modal.Body>
            <Form
                layout="horizontal"
                model={adminSkillTypeModel}
                onChange={handleFormChange}
                onSubmit={submitSkillTypeAdd}
            >
                <Form.Group>
                    <Form.ControlLabel>Skill Type Name</Form.ControlLabel>
                    <Form.Control name="skillTypeName"/>
                </Form.Group>
                <Form.Group>
                    <ButtonToolbar>
                        <Button type="submit" appearance="primary">
                            Ok
                        </Button>
                        <Button onClick={handleClose} appearance="default">
                            Cancel
                        </Button>
                    </ButtonToolbar>
                </Form.Group>
            </Form>
        </Modal>
    );
};


export default AddSkillTypeModal;